import { configureStore, Action, ThunkAction } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

import reducer from './reducer';

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'STATIONS/setStationsFitBounds',
          'STATIONS/setActionStationsFitBounds',
        ],
      },
    }),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers.concat(sentryReduxEnhancer),
});

if (import.meta.env.MODE === 'development' && import.meta.hot) {
  import.meta.hot.accept('./reducer', (newModule) => {
    const newRootReducer = newModule?.default;
    store.replaceReducer(newRootReducer);
  });
}
export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
